var _circle, _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPageLido(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 124,
    height: 124,
    viewBox: "0 0 124 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 62,
    cy: 62,
    r: 62,
    fill: "url(#paint0_linear_20213_57698)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.7248 29L77.0706 53.0201L61.7248 61.961L46.3789 53.0201L61.7248 29ZM51.0757 51.8824L61.7248 35.2158L72.3708 51.8824L61.7217 58.0889L51.0757 51.8793V51.8824Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M61.7024 67.25L43.8981 56.8799L43.4114 57.6394C40.7506 61.8051 39.5922 66.7545 40.1278 71.6684C40.6633 76.5822 42.8609 81.1658 46.3565 84.6605C50.4262 88.7298 55.9457 91.0159 61.7008 91.0159C67.456 91.0159 72.9755 88.7298 77.0452 84.6605C80.5408 81.1658 82.7384 76.5822 83.2739 71.6684C83.8095 66.7545 82.6511 61.8051 79.9903 57.6394L79.5005 56.8799L61.7024 67.25Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_20213_57698",
    x1: 62,
    y1: 0,
    x2: 62,
    y2: 124,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E28F83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4796F"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPageLido);
export default __webpack_public_path__ + "static/media/page-lido.41344c5d2191f136c0785c6b0d7d9ced.svg";
export { ForwardRef as ReactComponent };